export const createOrder = async (
  start_date: string,
  vehicle: string,
  duration: number,
  category: string,
  tguid: number | undefined,
  tgmsgid: number | undefined,
  tgbot: string | undefined
): Promise<any> => {
  const url = `${process.env.REACT_APP_WORKER_URL}/create-order`;
  const body = {
    customer: {
      name: 'John Doe',
      email: '',
      phone: '+37379000000',
    },
    products: [
      {
        product: 'vignette:ro',
        vehicle,
        start_date,
        duration,
        category,
      },
    ],
    tguid: tguid?.toString(),
    tgmsgid: tgmsgid?.toString(),
    tgbot: tgbot?.toString(),
  };
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(
        `Failed to create order: ${response.status} ${response.statusText}`
      );
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating order:', error);
    throw error;
  }
};
